import { Reveal } from "./Reveal";
import Button from "./Button";
import { BRAND_HIGHLIGHTS } from "../lib/data";

export default function BrandPartnerships() {
  return (
    <section id="for-brands" className="border-t border-charcoal py-16 sm:py-32" data-testid="for-brands">
      <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-7">
            <Reveal>
              <div className="label mb-6">Brand Partnerships</div>
              <h2 className="font-sans font-semibold uppercase text-warm text-4xl sm:text-6xl lg:text-7xl leading-[0.9] tracking-[-0.02em] max-w-2xl">
                The bridge between talent and brands.
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 max-w-xl text-silver text-lg leading-relaxed font-light">
                Connecting brands with the personalities shaping sports, entertainment and
                internet culture.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <Button as="a" href="#brand-inquiry" variant="primary" className="mt-10" data-testid="brands-cta">
                Work With Our Talent
              </Button>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <div className="border-t border-charcoal">
              {BRAND_HIGHLIGHTS.map((h, i) => (
                <Reveal key={h} delay={i * 0.05}>
                  <div className="group flex items-center justify-between py-5 border-b border-charcoal transition-colors duration-500 hover:pl-2">
                    <span className="font-sans text-warm text-lg sm:text-xl">{h}</span>
                    <span className="label !text-silver/40 group-hover:!text-warm transition-colors duration-500">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
